<template>
    <tr v-if="collapseActive" class="report__list_table_item_collapse_table">
        <td class="report__list_table_item_collapse_table_wrapper" colspan="6">
            <template v-if="requestPending">
                <component-loading></component-loading>
            </template>
            <template v-else>
                <template v-if="reportItems.length">
                    <table>
                        <list-table-head
                            :labels="[
                                'date', 'status', ''
                            ]"
                        />
                        <tbody>
                        <template
                            v-for="(reportItem, index) in reportItems"
                        >
                            <report-list-table-item-collapse-table-item
                                :item="reportItem"
                                :report-data="item"
                                :key="`report-list-table-item-collapse-table-item-${index}`"
                            ></report-list-table-item-collapse-table-item>
                        </template>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <component-empty-state
                        :title="''"
                        :content="'No data found.'"
                        :submit-button-active="false"
                        :size="'small'"
                    ></component-empty-state>
                </template>
            </template>
        </td>
    </tr>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import ReportListTableItemCollapseTableItem from '@/components/ebs/reports/list/ReportListTableItemCollapseTableItem'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'

export default {
  name: 'report-list-table-item-collapse-table',
  components: { ComponentEmptyState, ComponentLoading, ReportListTableItemCollapseTableItem, ListTableHead },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    reportItems () {
      return this.$store.getters.getEbsReportBuilderCustomScheduled
    }
  },
  watch: {
    collapseActive (value) {
      if (value) {
        this.getReportScheduled()
      }
    }
  },
  methods: {
    getReportScheduled () {
      const reportId = this.item.id
      this.requestPending = true
      this.$store.dispatch('ebsReportBuilderGetDefinedReportScheduled', reportId).finally(() => {
        this.requestPending = false
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportlisttableitemcollapse.scss";
</style>
